import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateProject from "Projects/routes/CreateProject";
import ProjectDetails from "Projects/routes/ProjectDetails";
export default store => {
  return {
    path: "timeline",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [CreateProject(store), ProjectDetails(store)],
  };
};
